export const common = {
  theme: "Theme",
  themeLight: "Light",
  themeDark: "Dark",
  actions: {
    add: "Add",
    cancel: "Cancel",
    clear: "Clear",
    close: "Close",
    confirm: "Confirm",
    create: "Create",
    delete: "Delete",
    download: "Download",
    edit: "Edit",
    filter: "Filter",
    import: "Import",
    next: "Next",
    previous: "Previous",
    remove: "Remove",
    reset: "Reset",
    save: "Save",
    saving: "Saving...",
    search: "Search",
    select: "Select",
    submit: "Submit",
    update: "Update",
    upload: "Upload",
    view: "View",
    back: "Back",
    finish: "Finish",
    refresh: "Refresh",
    retry: "Retry",
    preview: "Preview",
    copy: "Copy"
  },
  of: "of",
  save: "Save",
  saving: "Saving...",
  sending: "Sending...",
  syncing: "Syncing...",
  close: "Close",
  cancel: "Cancel",
  create: "Create",
  done: "Done",
  delete: "Delete",
  generating: "Generating...",
  coming_soon: "Coming soon...",
  actionButtons: "Actions",
  documentation: "Documentation",
  help_center: "Help Center",
  help: {
    userManual: "User Manual",
    guidedTour: "Guided Tour"
  },
  none: "None",
  error: "Error",
  success: "Success",
  warning: "Warning",
  info: "Information",
  loading: "Loading...",
  deleting: "Deleting...",
  noData: "No data available",
  selectOption: "Select an option",
  noOptionsAvailable: "No options available",
  pageNotFound: "Page not found",
  pageNotFoundDescription: "The page you are looking for does not exist or has been moved.",
  goBack: "Go back",
  goHome: "Go to home",
  noChanges: "No changes",
  noChangesDescription: "No changes have been made to save.",
  noResults: "No results found",
  pagination: {
    showing: "Showing {{start}} to {{end}} of {{total}} items",
    itemsPerPage: "Items per page",
    pageOfTotal: "Page {{current}} of {{total}}"
  },
  tryAgain: "Try again",
  errorLoadingData: "Error loading data",
  categories: {
    Files: "Files",
    Triggers: "Triggers",
    Embeddings: "Embeddings",
    API: "APIs",
    Databases: "Databases",
    "Knowledge Base": "Knowledge Base"
  },
  dates: {
    createdAt: "Created At",
    updatedAt: "Updated At",
    deletedAt: "Deleted At",
    format: {
      dateTime: "MM/DD/YYYY hh:mm A",
      date: "MM/DD/YYYY",
      time: "hh:mm A"
    }
  },
  pages: {
    agents: {
      settings: {
        parameters: {
          noParameters: "No parameters configured",
          addFirstParameter: "Add your first parameter",
          addParameter: "Add parameter",
          customField: "Custom Field",
          parameterName: "Parameter Name",
          parameterNamePlaceholder: "Enter parameter name",
          parameterType: "Parameter Type",
          parameterTypePlaceholder: "Select parameter type",
          required: "Required",
          string: "String",
          number: "Number",
          boolean: "Boolean",
          array: "Array",
          object: "Object"
        }
      }
    },
    knowledge: {
      title: "Knowledge",
      description: "Your workspace's second brain",
      tabs: {
        imports: "Imports",
        transformation: "Transformation",
        database: "Database",
        storage: "Storage",
        pipelines: "Pipelines",
        flows: "Flows"
      },
      imports: {
        title: "Imports",
        description: "Manage your imports",
        addButton: "Import",
        search: "Search imports...",
        searchTools: "Search tools...",
        selectTool: "Select a tool",
        empty: {
          title: "No imports found",
          description: "Add a new import to get started"
        },
        categories: {
          files: "Files",
          apis: "APIs",
          databases: "Databases",
          other: "Other"
        },
        status: {
          active: "Active",
          inactive: "Inactive",
          pending: "Pending",
          failed: "Failed",
          success: "Success",
          error: "Error",
          processing: "Processing"
        }
      },
      database: {
        title: "Database",
        description: "Manage your data",
        addButton: "Add",
        search: "Search tables...",
        empty: {
          title: "No tables found",
          description: "Add a new table to get started"
        },
        details: {
          title: "Details",
          description: "Table details"
        },
        fields: {
          filterBy: "Filter by",
          type: "Type",
          id: "ID",
          name: "Name",
          status: "Status",
          description: "Description",
          createdAt: "Created At",
          updatedAt: "Updated At",
          deletedAt: "Deleted At",
          insertedAt: "Inserted At",
          reference: "Reference",
          content: "Content",
          error: "Error",
          retries: "Retries",
          nextRetry: "Next Retry",
          lastRetry: "Last Retry",
          source: "Source",
          destination: "Destination",
          schedule: "Schedule",
          enabled: "Enabled",
          properties: "Properties",
          metadata: "Metadata",
          actions: "Actions",
          actionItems: {
            view: "View",
            edit: "Edit",
            delete: "Delete",
            export: "Export",
            import: "Import"
          }
        },
        messages: {
          deleteConfirm: "Are you sure you want to delete this table?",
          deleteSuccess: "Table deleted successfully",
          deleteError: "Error deleting table",
          fetchError: "Error loading tables"
        },
        columns: {
          common: {
            pages: {
              knowledge: {
                database: {
                  fields: {
                    id: "ID",
                    insertedAt: "Inserted At",
                    type: "Type",
                    reference: "Reference",
                    content: "Content",
                    metadata: "Metadata",
                    version: "Version",
                    actions: "Actions",
                    basicInfo: "Basic Information"
                  }
                }
              }
            }
          }
        }
      },
      transformation: {
        title: "Transformation",
        description: "Transform your data",
        nodes: "Transformation Nodes",
        flowTypes: {
          categories: {
            transformation: "Transformation",
            filter: "Filters",
            aggregation: "Aggregation",
            enrichment: "Enrichment",
            validation: "Validation",
            embeddings: "Embeddings",
            models: "AI Models",
            import_tools: "Tools"
          },
          names: {
            "String Manipulation": "String Manipulation",
            "Number Operations": "Number Operations",
            "Date Formatting": "Date Formatting",
            "Filter Rows": "Filter Rows",
            "Remove Duplicates": "Remove Duplicates",
            "Group By": "Group By",
            "Pivot Table": "Pivot Table",
            "Lookup": "Lookup",
            "Custom Formula": "Custom Formula",
            "Data Quality Check": "Data Quality Check",
            "Schema Validation": "Schema Validation",
            "Text to Vector": "Text to Vector",
            "Vector Search": "Vector Search",
            "Embedding Clustering": "Embedding Clustering",
            "Text Generation": "Text Generation",
            "Text Classification": "Text Classification",
            "Sentiment Analysis": "Sentiment Analysis",
            "Question Answering": "Question Answering",
            "Text Summarization": "Text Summarization",
            "CSV Import": "CSV Import",
            "Excel Import": "Excel Import",
            "JSON Import": "JSON Import",
            "Database Import": "Database Import",
            "API Import": "API Import",
            "Text Import": "Text Import",
            "XML Import": "XML Import",
            "Google Sheets Import": "Google Sheets Import",
            "Web Scraping Import": "Web Scraping Import",
            "FTP Import": "FTP Import"
          },
          descriptions: {
            "String Manipulation": "Transform text data using various string operations",
            "Number Operations": "Perform mathematical operations on numeric data",
            "Date Formatting": "Convert and format date/time values",
            "Filter Rows": "Filter data based on conditions",
            "Remove Duplicates": "Remove duplicate entries from data",
            "Group By": "Group data by specific fields",
            "Pivot Table": "Create pivot tables from data",
            "Lookup": "Enrich data using lookup tables",
            "Custom Formula": "Apply custom formulas to data",
            "Data Quality Check": "Validate data against rules",
            "Schema Validation": "Validate data structure",
            "Text to Vector": "Convert text into vector embeddings for semantic search and similarity analysis",
            "Vector Search": "Search through vector embeddings to find similar content",
            "Embedding Clustering": "Group similar embeddings together using clustering algorithms",
            "Text Generation": "Generate text using large language models",
            "Text Classification": "Classify text into predefined categories using AI models",
            "Sentiment Analysis": "Analyze sentiment and emotions in text using AI",
            "Question Answering": "Answer questions based on provided context using LLMs",
            "Text Summarization": "Generate concise summaries of longer texts using AI",
            "CSV Import": "Import data from CSV files with configurable delimiter and encoding",
            "Excel Import": "Import data from Excel files (XLSX/XLS) with support for multiple sheets",
            "JSON Import": "Import data from JSON files or APIs with nested structure support",
            "Database Import": "Import data from various database systems using SQL queries",
            "API Import": "Import data from REST or GraphQL APIs with authentication support",
            "Text Import": "Import data from plain text files with custom parsing rules",
            "XML Import": "Import data from XML files with XPath query support",
            "Google Sheets Import": "Import data directly from Google Sheets with OAuth authentication",
            "Web Scraping Import": "Import data by scraping web pages using CSS selectors or XPath",
            "FTP Import": "Import data from files hosted on FTP/SFTP servers"
          }
        }
      }
    }
  },
  labels: {
    name: "Name",
    type: "Type",
    status: "Status",
    actions: "Actions",
    description: "Description",
    createdAt: "Created at",
    updatedAt: "Updated at",
    category: "Category",
    configuration: "Configuration",
    settings: "Settings"
  },
  messages: {
    deleteSuccess: "Item deleted successfully",
    deleteSuccessDescription: "The item has been deleted successfully.",
    deleteError: "Error deleting item. Please try again.",
    deleteConfirmationTitle: "Delete item",
    deleteConfirmationDescription: "Are you sure you want to delete this item? This action cannot be undone.",
    loading: "Loading...",
    error: "Error",
    errorDescription: "An error occurred. Please try again.",
    success: "Success",
    confirmDelete: "Are you sure you want to delete?",
    noResults: "No results found",
    required: "Required field",
    select: "Select",
    copied: "Copied!",
    pageNotFound: "Page not found",
    pageNotFoundDescription: "The page you are looking for does not exist or has been moved.",
    goBack: "Go back",
    goHome: "Go to home"
  },
  workspaces: {
    addWorkspace: "Workspace",
    selectWorkspace: "Select a Workspace",
    selectWorkspaceDescription: "To access the agents and resources, please select a workspace from the menu above.",
    emptyState: {
      title: "Everything starts with a workspace",
      description: "Bring your team, projects, and AI agents together. Create your first workspace to start managing workflows, knowledge bases, and everything your product needs.",
      adminAction: "Create your first Workspace to unlock all platform features.",
      userMessage: "Please contact your administrator to create a Workspace and get started.",
      noOrganizationWarning: "You need to complete the organization setup before creating a Workspace. Please finish the onboarding process first."
    }
  },
  poweredBy: "Powered by",
  companyName: "Programmers",
  trademark: "®",
  optional: "optional",
  characters: "characters",
  all: "All",
  errors: {
    notAuthenticated: "User not authenticated",
    organizationNotFound: "Organization not found",
  },
} as const;

export default common;
